var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _path4, _linearGradient4, _path5, _path6, _path7, _linearGradient5, _path8, _path9, _path10, _path11, _path12, _path13, _linearGradient6, _path14, _linearGradient7, _path15, _linearGradient8, _path16, _linearGradient9, _path17, _linearGradient10, _path18, _linearGradient11, _path19, _linearGradient12, _path20, _linearGradient13, _path21, _linearGradient14, _path22, _linearGradient15, _path23, _path24, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMercedes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 7.998,
    x2: 56.002,
    y1: 54.102,
    y2: 13.898,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e7e8e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#cdd0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#b5bbbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a5acaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9ba3a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#98a0a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#828a8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#667075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#535c63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#475158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#434d54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475157"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M63.3 32c0 17.3-14 31.3-31.3 31.3S.7 49.3.7 32 14.7.7 32 .7s31.3 14 31.3 31.3zM32 2.6C15.7 2.6 2.6 15.7 2.6 32S15.8 61.4 32 61.4c16.3 0 29.4-13.2 29.4-29.4C61.4 15.7 48.3 2.6 32 2.6z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 9.471,
    x2: 54.471,
    y1: 52.941,
    y2: 15.141,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b1f2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#333f47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#777f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#81898d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#b3b8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d2d5d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#dee0dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbfbfb"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M32 2.6C15.7 2.6 2.6 15.7 2.6 32S15.8 61.4 32 61.4c16.3 0 29.4-13.2 29.4-29.4C61.4 15.7 48.3 2.6 32 2.6zm0 56.9C16.8 59.5 4.5 47.2 4.5 32S16.8 4.5 32 4.5 59.5 16.8 59.5 32 47.2 59.5 32 59.5z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1648.736,
    x2: 1670.636,
    y1: -160.944,
    y2: -221.143,
    gradientTransform: "matrix(-1 0 0 1 1691.673 223.007)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1e3e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#c1c5c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9ba1a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7d8487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#687074",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5b6469",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576065",
    stopOpacity: 0
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M32 63.3c17.3 0 31.3-14 31.3-31.3S49.3.7 32 .7.7 14.7.7 32s14 31.3 31.3 31.3zM32 0c17.6 0 32 14.4 32 32S49.6 64 32 64 0 49.6 0 32 14.4 0 32 0z",
    opacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.2 32.1C2.2 15.7 15.5 2.2 32 2.2s29.8 13.4 29.8 29.9c0 16.4-13.3 29.7-29.8 29.7S2.2 48.5 2.2 32.1zm9.3-20.6c-5.3 5.3-8.6 12.6-8.6 20.6 0 8 3.3 15.3 8.5 20.5 5.3 5.2 12.6 8.5 20.6 8.5 8 0 15.3-3.2 20.5-8.5 5.3-5.2 8.5-12.5 8.5-20.5s-3.3-15.3-8.5-20.6C47.3 6.2 40 2.9 32 2.9s-15.3 3.3-20.5 8.6z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 18.201,
    x2: 45.799,
    y1: 57.899,
    y2: 10.101,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1e3e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#c1c5c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9ba1a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7d8487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#687074",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5b6469",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576065",
    stopOpacity: 0
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M32 59.6c-7.4 0-14.3-2.9-19.5-8.1S4.4 39.4 4.4 32s2.9-14.3 8.1-19.5S24.6 4.4 32 4.4s14.3 2.9 19.5 8.1 8.1 12.1 8.1 19.5-2.9 14.3-8.1 19.5-12.1 8.1-19.5 8.1zm0-.8c7.1 0 13.9-2.8 18.9-7.8 5.1-5.1 7.8-11.8 7.8-18.9s-2.8-13.9-7.8-18.9C45.8 8.1 39.1 5.4 32 5.4s-13.9 2.8-18.9 7.8C8 18.1 5.2 24.9 5.2 32S8 45.9 13 50.9c5.1 5.1 11.9 7.9 19 7.9z",
    opacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.3 45c-.5-.4-19.8-15.7-19.8-15.7L32 3.6c-.3.1-.7.4-.9.8l-3.2 25L8 44.7s-.4.5-.6.8c-.1.2-.1.5-.1.8l24.6-10.1 24.6 10.1c.2-.5 0-1-.2-1.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#565f64",
    d: "M32.2 32.8l-.2 4.6 22.6 9.1c.8.4 1.4.2 2-.2L32.5 32.7c-.1-.1-.3 0-.3.1z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 44.488,
    x2: 42.788,
    y1: 26.607,
    y2: 23.807,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#27343c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00111e",
    stopOpacity: 0
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M32.2 32.8s1.3 2.3 2.8 3.9c2.1 2.3 4.9 3.9 4.9 3.9l14.7 5.9c.8.4 1.4.2 2-.2L32.5 32.7c-.1-.1-.3 0-.3.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4aaae",
    fillOpacity: 0.6,
    d: "M56.5 45.4c0-.1-.1-.2-.2-.4L35.7 29.9l-2.8 1.8s.2.1.3 0c.3-.1.9-.2 1.5 0 .5.2 21.8 13.8 21.8 13.7 0 .1 0 .1 0 0z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#333e46",
    d: "M55.8 44.5L36.6 29.3l-.9.6 20.6 15.2c-.1-.2-.3-.4-.5-.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#565f64",
    d: "M32.5 31.3l-.1.1s0 .2.2.1c.1-.1 3-1.6 4-2.2l-3.5-24c-.1-.9-.5-1.3-1.2-1.6l.4 27.8.2-.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4aaae",
    fillOpacity: 0.6,
    d: "M30.8 5.3v1.3l-2.2 22.1c0 .3.1.6.4.8l1.3 1 .9-24.4.1-1.9c-.3.2-.4.6-.5 1.1zm-1.2 25.6l-1.2-1L8.1 44.6s-.6.4-.7.8l.7-.4 21.3-13.4c.4-.2.5-.4.2-.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#565f64",
    d: "M31.7 32.8c0-.1-.1-.2-.2-.1L7.3 46.4c.6.4 1.2.5 2 .2l22.6-9.1-.2-4.7z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 39.58,
    x2: 36.78,
    y1: 36.888,
    y2: 41.388,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#02131f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#02131f",
    stopOpacity: 0
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M32.4 31.4l.1-.1-.1.1s0 .1.1.1h.1c.1-.1 3-1.6 4-2.2l-.4-2.9-3.1-21.1c0-.4-.1-.7-.3-.9 0 0 1.5 20.2 1.5 22.4 0 2.9-1.9 4.6-1.9 4.6z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 31.982,
    x2: 27.782,
    y1: 29.664,
    y2: 28.464,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#02131f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#02131f",
    stopOpacity: 0
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    fillOpacity: 0.8,
    d: "M31.7 32.8c0-.1-.1-.2-.2-.1L7.3 46.4c.6.4 1.2.5 2 .2l22.6-9.1-.2-4.7z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 20.791,
    x2: 20.191,
    y1: 24.096,
    y2: 25.596,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02131f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#02131f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02131f",
    stopOpacity: 0
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M9.3 46.5l22.6-9.1-.2-4.4c-.4 1.2-1.1 2.5-3 3.5-1.4.8-14.8 7.4-19.6 9.7-.3.2-.7.3-.9.4.4.2.7.1 1.1-.1z",
    opacity: 0.8
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 35.602,
    x2: 32.202,
    y1: 48.786,
    y2: 48.386,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#02131f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#02131f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#02131f",
    stopOpacity: 0
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M32.5 31.3l-.1.1s0 .2.2.1c.1-.1 3-1.6 4-2.2l-3.5-24c-.1-.9-.5-1.3-1.2-1.6l.4 27.8.2-.2z"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 35.708,
    x2: 33.407,
    y1: 48.843,
    y2: 48.543,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#27343c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b474e",
    stopOpacity: 0
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M32.5 31.3l-.1.1s0 .2.2.1c.1-.1 3-1.6 4-2.2l-3.5-24c-.1-.9-.5-1.3-1.2-1.6l.4 27.8.2-.2z"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -0.36,
    x2: 27.54,
    y1: 33.169,
    y2: 17.069,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#24303a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25323b",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#27343c"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M5.1 44.4C4.4 42.8.4 35 4.8 20H3.1c-.9 3-1.6 4.8-2 7.5 0 0-.2 1-.3 2.1S.7 31.3.7 32c0 6 1.5 9.5 1.5 9.5 1.6 5 4.4 9.5 8.2 12.9 3.3 2.9 8.4 5.1 12.6 5.9-.7-.1-12.7-5.2-17.9-15.9z"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 31.95,
    x2: 31.95,
    y1: 28.6,
    y2: 33.4,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#a5abaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a5abaf",
    stopOpacity: 0
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M32.4 32.6h-.9c.1 0 .2 0 .2.1l.2 4.6h.1l.2-4.6c0-.1.1-.2.2-.1z"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 47.65,
    x2: 47.65,
    y1: 63.7,
    y2: 2.7,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dee0dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5c9c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ea4a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#82898c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#71797d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b7378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#333f47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#27343c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#333f47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434d54"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M42 2.3c10.5 4 20.4 15 20.4 28.9C62.4 48 49 61.7 32 61.7v1.6c17 0 31.3-14 31.3-31.3 0-13.8-8.8-25.4-21.3-29.7z"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 32,
    x2: 32.3,
    y1: 65.3,
    y2: 65.3,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dee0dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5c9c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ea4a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#82898c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#71797d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b7378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#333f47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#27343c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#333f47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434d54"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M32.3.7H32h.3z"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 57.289,
    x2: 43.789,
    y1: 57.907,
    y2: 38.107,
    gradientTransform: "matrix(1 0 0 -1 0 66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#27343c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2b373f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#36424a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#49545b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#646d73",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#868d92",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#b0b5b8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#e1e3e4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M58.8 20.2C51.8 4.1 36 3.2 35.1 3.1H35c12.1 2.2 19.8 10.1 22.5 18.4v.1c1.2 3.2 1.8 6.6 1.9 10.3.1 3.5-.7 7.4-2.2 11-.1.5-.2 1.1-.3 1.1h1.6c4.8-9 2.7-18.1.3-23.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbfbfb",
    d: "M2.2 32.1C2.2 15.7 15.5 2.2 32 2.2s29.8 13.4 29.8 29.9c0 16.4-13.3 29.7-29.8 29.7S2.2 48.5 2.2 32.1zm9.3-20.6c-5.3 5.3-8.6 12.6-8.6 20.6 0 8 3.3 15.3 8.5 20.5 5.3 5.2 12.6 8.5 20.6 8.5 8 0 15.3-3.2 20.5-8.5 5.3-5.2 8.5-12.5 8.5-20.5s-3.3-15.3-8.5-20.6C47.3 6.2 40 2.9 32 2.9s-15.3 3.3-20.5 8.6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#333f47",
    d: "M7.9 44.8l20.4-14.7c1.1.6 2.9 1.4 3.1 1.4.2.1.2-.1.2-.1l-2.5-2.1c-.3-.2-.4-.5-.4-.8l2.4-24.1c-.1.1-.1.3-.2.4-.1.2-.1.3-.1.5l-3.5 24.1L8.1 44.5c-.1.1-.2.2-.2.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercedes);
export default __webpack_public_path__ + "static/media/mercedes.7b11f7ee2ef4792abd9943cdb7a9fa14.svg";
export { ForwardRef as ReactComponent };